import React from 'react'

import { 
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Divider,
  Grid,
} from '@material-ui/core';

import HighlightOff from '@material-ui/icons/HighlightOff'
import Cancel from '@material-ui/icons/Cancel'
import Refresh from '@material-ui/icons/Refresh'
import Edit from '@material-ui/icons/Edit'
import MoveToInbox from '@material-ui/icons/MoveToInbox'
import Smile from '@material-ui/icons/SentimentSatisfiedOutlined';
import Closed from '@material-ui/icons/AssignmentTurnedInOutlined'
import CheckedIn from '@material-ui/icons/PlaylistAddCheckOutlined';
import Replay from '@material-ui/icons/Replay';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import moment from 'moment';

export default function Activity({activities}) {

  const renderActivityTitle = activity => {
    switch(activity.type) {
      case 'pending':
        return <><Refresh style={{fontSize: '20px', marginRight: '10px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>Re-submitted</strong> by {activity.account.name}</>
      case 'rejected':
        return <><HighlightOff style={{fontSize: '20px', marginRight: '10px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>Rejected</strong> by {activity.account.name}</>
      case 'canceled':
        return <><Cancel style={{fontSize: '20px', marginRight: '10px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>Canceled</strong> by {activity.account.name}</>
      case 'updated':
        return <><Edit style={{fontSize: '22px', marginRight: '12px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>Edited</strong> by {activity.account.name}</>
      case 'received':
        return <><CheckedIn style={{fontSize: '22px', marginRight: '10px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} />{activity.account.name} <strong>edited received items</strong></>
      case 'setReceivedStatus':
        return <><CheckedIn style={{fontSize: '22px', marginRight: '10px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>All items received</strong></>
      case 'unreceived':
        return <><Replay style={{fontSize: '22px', marginRight: '10px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>Items unreceived</strong></>
      case 'created':
        return <><MoveToInbox style={{fontSize: '22px', marginRight: '10px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>Created</strong> by {activity.account.name}</>
      case 'closed':
        return <><Closed style={{fontSize: '22px', marginRight: '10px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>Closed</strong> by {activity.account.name}</>
      case 'approved':
        return <><Smile style={{fontSize: '20px', marginRight: '12px', lineHeight: '29px', display: 'inline-block', verticalAlign: 'top'}} /><strong>Approved</strong> by {activity.account.name}</>
      default:
        return null;
    }
  }

  const renderActivity = activity => (
    <div style={{position: 'relative'}}>
      <Typography>
        {renderActivityTitle(activity)}
      </Typography>
      <Typography variant='overline' style={{position: 'absolute', right: 0, top: 0}}>
        {moment(activity.updatedAt/1000).format('LLL')}
      </Typography>
      { activity.type === 'created' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>Comment: {activity.text}</span> }
      { activity.type === 'updated' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>{activity.text}</span> }
      { activity.type === 'rejected' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>Comment: {activity.text}</span> }
      { activity.type === 'canceled' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>Comment: {activity.text}</span> }
      { activity.type === 'approved' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>Comment: {activity.text}</span> }
      { activity.type === 'pending' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>Comment: {activity.text}</span> }
      { activity.type === 'received' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>Marked total received as {activity.text}</span> }
      { activity.type === 'unreceived' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>{activity.text}</span> }
      { activity.type === 'setReceivedStatus' && activity.text && <span style={{fontSize: '12px', color: '#777'}}>{activity.text}</span> }
    </div>
  )

  return activities && activities.length > 0 ? <div style={{margin: '0 16px', maxWidth: '800px'}}>
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography variant="overline">Activity</Typography>
      </AccordionSummary>
      <Divider/>
      <AccordionDetails style={{padding: 0}}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {activities.map(activity => (
              <Box sx={{p: 2, m: 1, border: '1px solid silver'}} key={activity.id}>{renderActivity(activity)}</Box>
            )) }
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  </div> : null
  
}
